import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function Layout() {
  const { user, logout } = useAuth();
  return <div className="site-shell">
    <header className="site-header">
      <NavLink to="/" className="brand"><span className="brand-mark">五</span><span>Sonic Five Elements</span></NavLink>
      <nav aria-label="Main navigation">
        <NavLink to="/create">Create</NavLink>
        <NavLink to="/pricing">Pricing</NavLink>
        {user && <NavLink to="/library">My Music</NavLink>}
      </nav>
      <div className="header-account">
        {user ? <><span className="credit-chip">{user.creditBalance} credits</span><NavLink className="text-button" to="/account">Account</NavLink><button className="text-button" onClick={() => void logout()}>Sign out</button></> : <NavLink className="small-cta" to="/account">Sign in</NavLink>}
      </div>
    </header>
    <main><Outlet /></main>
    <footer>
      <div><span className="brand-mark small">五</span> Sonic Five Elements</div>
      <p>AI-generated instrumental music inspired by cultural traditions. Not medical treatment or advice.</p>
      <div className="footer-links"><NavLink to="/terms">Terms</NavLink><NavLink to="/privacy">Privacy</NavLink><NavLink to="/refund">Refunds</NavLink><NavLink to="/ai-content-policy">AI Policy</NavLink></div>
    </footer>
  </div>;
}
